import * as React from 'react';
import * as influence from "./style.module.scss";

export const Influence = () => {
  return (
    <section className={influence.influence}>
      <div className="container">
        <div className={influence.influence__wrapper}>
          <div className={influence.influence__image}>
            <img
              src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/influence-img.png"
              alt=""
            />
          </div>
          <div className={influence.influence__content}>
            <h4>Что даст курс</h4>
            <div className={influence.influence__contentText}>
              <p><strong>Родитель</strong> узнает, как помочь ребёнку избавиться от сложностей в чтении и как привить
                ему любовь к этому занятию.
              </p>
              <p><strong>Ребёнок</strong> увеличит скорость чтения, будет лучше понимать прочитанное, научится грамотно
                пересказывать тексты. Это даст возможность легко воспринимать учебную программу, самостоятельно и с
                удовольствием читать художественную литературу.</p>
            </div>
          </div>
        </div>
        <div className={influence.influence__process}>
          <h4>Как проходят занятия</h4>
          <div className={influence.influence__processBlocks}>
            <div className={influence.influence__processBlock}>
              <video
                controls
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/video/palchikovaya-gimnastika.MOV"
              ><track kind={"captions"}/></video>
              <p>Пальчиковая гимнастика</p>
            </div>
            <div className={influence.influence__processBlock}>
              <video
                controls
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/video/zapominanie-flagov.MOV"
              ><track kind={"captions"}/></video>
              <p>Запоминание флагов</p>
            </div>
            <div className={influence.influence__processBlock}>
              <video
                controls
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/video/tehnika-uskoreniya-scheta.MOV"
              ><track kind={"captions"}/></video>
              <p>Техника ускорения счёта</p>
            </div>
            <div className={influence.influence__processBlock}>
              <video
                controls
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/video/zapominanie-granits-kontinentov.MOV"
              ><track kind={"captions"}/></video>
              <p>Запоминание границ континентов</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
